export default __webpack_public_path__ + "static/media/sliders--gradient.3ce55b02.svg";